// AppFooter.jsx
import React from 'react';
import { Row, Col, Typography, Divider, Space, Button } from 'antd';
import { 
  GlobalOutlined, 
  PhoneOutlined, 
  MailOutlined, 
  GithubOutlined,
  InfoCircleOutlined,
  CopyrightOutlined,
  BuildOutlined,
  MessageOutlined
} from '@ant-design/icons';

const { Text, Link } = Typography;

export const AppFooter = ({ supportLinks, handleViewChange }) => {
  const currentYear = new Date().getFullYear();
  const persianYear = currentYear - 621; // تبدیل به سال شمسی

  return (
    <div style={{ 
      padding: '16px 24px', 
      background: '#fafafa',
      borderTop: '1px solid #f0f0f0',
      marginTop: 24
    }}>
      <Row gutter={[24, 16]}>
        <Col xs={24} md={8}>
          <Space direction="vertical" size="small">
            <Text strong>
              <BuildOutlined style={{ marginLeft: 8 }} />
              سامانه رزرواسیون حسینیه من
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              نسخه 404.4.1 (1404/10/05)
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              <CopyrightOutlined style={{ marginLeft: 4 }} />
              کلیه حقوق محفوظ است {persianYear} ©
            </Text>
          </Space>
        </Col>

        <Col xs={24} md={8}>
          <Space direction="vertical" size="small">
            <Text strong>تهیه‌کننده</Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              گروه نرم افزاری الماس اسپادانا
            </Text>
            <Button 
              type="link" 
              size="small" 
              onClick={() => handleViewChange('developer')}
              style={{ padding: 0, height: 'auto' }}
            >
              <InfoCircleOutlined style={{ marginLeft: 4 }} />
              اطلاعات تماس
            </Button>
          </Space>
        </Col>

        <Col xs={24} md={8}>
          <Space direction="vertical" size="small">
            <Text strong>ارتباط با ما</Text>
            <Button 
              type="link" 
              size="small" 
              onClick={() => handleViewChange('website')}
              style={{ padding: 0, height: 'auto' }}
            >
              <GlobalOutlined style={{ marginLeft: 4 }} />
              وب‌سایت اطلاع‌رسانی
            </Button>
            <Button 
              type="link" 
              size="small" 
              onClick={() => handleViewChange('support-contact')}
              style={{ padding: 0, height: 'auto' }}
            >
              <PhoneOutlined style={{ marginLeft: 4 }} />
              پشتیبانی و راهنمای رزرو
            </Button>
            <Button 
    type="link" 
    size="small" 
    onClick={() => window.open('https://eitaa.com/hoseinienajafabadiha', '_blank')}
    style={{ padding: 0, height: 'auto' }}
>
    <MessageOutlined style={{ marginLeft: 4 }} />
    کانال ایتا
</Button>
          </Space>
        </Col>
      </Row>

      <Divider style={{ margin: '16px 0' }} />

      {/* <Row justify="center">
        <Col>
          <Text type="secondary" style={{ fontSize: 11 }}>
             این سامانه با React و Ant Design توسعه یافته است 
                طراحی و توسعه سامانه توسط علی عابدینی ©
          </Text>
        </Col>
      </Row> */}
    </div>
  );
};